import type { OrderAttribute } from "@jti/magento";

export const sortAttributes = (attrs: OrderAttribute[]) =>
  attrs
    .map((attr) => structuredClone(attr))
    .sort((a, b) => {
      if (Number.isFinite(a.sort_order) && Number.isFinite(b.sort_order)) {
        return a.sort_order - b.sort_order;
      }
      return 0;
    });
